import styled from 'styled-components';
import { FormConfigurationProvider, ModelCheckbox } from '@equifinance/shared';
import { formatDateTime } from '@equifinance/shared/utils';
import {
  Divider, InfoPanel, SubmitContainer, SubmittedText,
} from '../../components/UnderwriterDecision';
import { PolicyShieldsRuleOutcomeType, useChecklistContext } from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import RuleOutcomeSection from './Sections/RuleOutcomeSection';
import { PolicyShieldUnderwriterDecision } from './Sections/UnderwriterDecison';
import { usePageConfigurationContext } from '../../../../contexts/pageConfiguration';

export const PolicyShieldsRefName = 'policy-shields';

const SectionGuide = styled.p`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[2]};;
`}`;

const ButtonContainer = styled.div`
  width: fit-content;
`;

export default function PolicyShieldsSection() {
  const { checklist } = useChecklistContext();

  const {
    policyShields, errors, warnings,
  } = checklist ?? {};

  const { isReadOnly: isPageReadOnly } = usePageConfigurationContext();
  const {
    submitted, checklistIndicatorType, submittedByName, submittedTimestamp, canSubmit,
  } = policyShields ?? {};

  const isSectionDisabled = submitted || checklistIndicatorType === 'Locked' || isPageReadOnly;

  return (
    <PaddedGenericSection
      refName={PolicyShieldsRefName}
      section={ChecklistSection.POLICY_SHIELDS}
      checklistItem={policyShields}
      subSection={ChecklistSection.NOTES_POLICY_SHIELDS}
      errors={errors}
      warnings={warnings}
    >
      <SectionGuide>
        Please review each item individually, you will need to make a decision per item and give a justification for this decision.
        An overall justification will also need to be given by the authorisor.
      </SectionGuide>

      <FormConfigurationProvider isReadOnlyInput={isSectionDisabled}>
        <RuleOutcomeSection ruleOutcomeType={PolicyShieldsRuleOutcomeType.Referral} subSection={ChecklistSection.POLICY_SHIELDS_REFERRALS} />
        <RuleOutcomeSection ruleOutcomeType={PolicyShieldsRuleOutcomeType.Rejection} subSection={ChecklistSection.POLICY_SHIELDS_REJECTIONS} />
        <PolicyShieldUnderwriterDecision />
      </FormConfigurationProvider>

      <SubmitContainer>
        {submitted && submittedByName && submittedTimestamp && (
          <InfoPanel>
            <SubmittedText>
              {submittedByName}
            </SubmittedText>
            <Divider />
            <SubmittedText>
              {formatDateTime(submittedTimestamp, 'DD/MM/YYYY, HH:mm:ss')}
            </SubmittedText>
          </InfoPanel>
        )}
        <ButtonContainer>
          <ModelCheckbox
            label="Mark as complete"
            field="policyShields.submitted"
            disabled={!canSubmit || checklistIndicatorType === 'Locked'}
            successColor={submitted}
            isCompleteCheckbox
          />
        </ButtonContainer>
      </SubmitContainer>
    </PaddedGenericSection>
  );
}
